import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex); // Vue.use引用

// 放置公用数据
const state = {
  filter: false, // 网页滤镜（重要节日首页置灰处理）
  // 判断登录
  sysName: "贴现平台", // 系统名称
  userId: "", //用户ID
  user: {
    userInfo: {
      headPhoto: ""
    }
  }, // user信息
  userPhone: "", // 当前登录的手机号码
  sysUserAvatar:
    "https://raw.githubusercontent.com/taylorchen709/markdown-images/master/vueadmin/user.png", // 用户头像
  token: "",
  webInfo: {}, // 平台信息
  // 贴现利率
  discountRate: "",
  discountRouterIsShow: false, // 快贴代理人路由是否展示
  // 临时保存相关数据增强用户体验
  currentData: {},

  eventCount: 0, // 待办事项的数量
  orderCount: 0, // 商票和银票进行中的订单
  orderCountSP: 0, // 商票的订单数量
  orderCountYP: 0, // 银票的订单数量

  // 充值服务费密码弹框是否展示
  recharge_modal: false,
  // 更改登录密码弹框是否展示
  password_modal: false,
  // 公共弹框是否展示
  showPopups: false,
  // 登录弹框是否展示
  loginStatus: false,
  // 提示弹框是否展示
  tipStatus: false,
  tipContent: {
    // 提示内容
    tipMessage: "您还未与该银行进行签约，无法发起贴现<br/>是否立即前往签约", // 提示信息
    closeStyle: "", // 关闭按钮的样式
    tipLogo: "", // 提示logo
    tipButtonLeft: "", // 左按钮名称
    tipButtonLeftType: "", // 左按钮类型
    tipButtonRight: "", // 右按钮名称
    tipButtonRightType: "", // 右按钮类型
    tipButtonLeftCall: function() {}, // 左按钮回调
    tipButtonRightCall: function() {}, // 右按钮回调
    title: "提示", // 顶部title
    closeCallback: "", // 关闭弹框的回调函数
    bottom: "", // 底部文字
    bottomCall: function() {} // 底部回调函数
  },
  // 新用户红包弹框是否展示
  redStatus: false,
  drawDownStatus: true,
  drawUpStatus: false,

  // 老用户红包弹框是否展示
  redOldStatus: false,
  drawDownOldStatus: true,
  drawUpOldStatus: false,
  // 红包类型
  redType: "", // 1：新用户2：老用户红包
  // 红包金额
  redAmount: "",
  // 当前参与红包的内容
  redContent: "",
  // 当前参与红包的pkId
  redPkId: "",

  // sendUrl: "http://192.168.1.58:8585", // "http://101.69.248.38:9999" // 指定url路径,用于请求的路径拼接
  sendUrl: process.env.API_ROOT, // "http://101.69.248.38:9999" // 指定url路径,用于请求的路径拼接

  uploadUrl: process.env.API_ROOT + "/file/upload",
  downloadUrl: process.env.API_ROOT + "/file/download",
  imageUrl: process.env.API_ROOT + "/file/image",

  // 银行标识和银行图标的对应
  bankImgCss: {
    fm: "fm_logo_img",
    ms: "ms_logo_img",
    zs: "zs_logo_img",
    zx: "zx_logo_img",
    gd: "gd_logo_img",
    gf: "gf_logo_img"
  },

  pageSize: [5, 10, 20, 25], // 分页页码条数选择

  amountTimer: "", // 主页吞吐量定时

  // 数据字典
  publicData: {
    // 发票申请状态
    invoiceApplicationStatus: {
      "1": "未申请",
      "2": "待开具",
      "3": "开票成功",
      "4": "待作废",
      "5": "已作废",
      "6": "作废失败",
      "7": "已红冲",
      "8": "开票失败",
      "9": "申请已撤回"
    },
    // 发票状态
    invoiceStatus: {
      "1": "正常",
      "2": "作废",
      "3": "红冲"
    },
    // 发票介质
    invoiceMedium: {
      E: "电子发票",
      P: "纸质发票"
    },
    // 发票类型
    invoiceType: {
      GENERAL: "增值税普通发票",
      SPECIAL: "增值税专用发票"
    },
    // 收款方式
    getMoneyType: {
      wx: "微信",
      zfb: "支付宝",
      pob: "个人网银账户",
      eob: "企业网银账户"
    },
    // 佣金申请状态
    commissionStatus: {
      "01": "平台处理中",
      "02": "提佣成功",
      "09": "驳回申请"
    },
    // 银行签约状态转换
    signStatus: {
      NO_CREDIT: "未签约",
      ENTERING: "签约中",
      CREDITING: "签约中",
      CREDIT_FAIL: "签约失败",
      CREDIT_EXCEPTION: "签约异常",
      CREDIT_SUCCESS: "已签约"
    },
    // 服务费充值方式类型
    serviceRechargeType: {
      1: {
        icon: "",
        name: "交易服务费"
      },
      2: {
        icon: "alipay_img",
        name: "微信充值"
      },
      3: {
        icon: "wxpay_img",
        name: "支付宝充值"
      }
    },
    // draftType: 票据类型
    draftType: {
      BANK_ACCEPTANCE_DRAFT: "银行承兑汇票",
      FINACE_DRAFT: "财务承兑汇票",
      TRADE_ACCEPTANCE_DRAFT: "商业承兑汇票"
    },
    // bankChannelType：银行渠道类型
    bankChannelType: {
      ZBANK: "武汉众邦银行",
      ZHENX: "辽宁振兴银行",
      FM: "富民银行",
      TEST: "测试银行"
    },
    // acceptBankLevelType：承兑行等级
    acceptBankLevelType: {
      BANK_ONE: "一类银行",
      BANK_TWO: "二类银行",
      BANK_THREE: "三类银行",
      BANK_FOUR: "四类银行",
      BANK_FIVE: "五类银行",
      BANK_SIX: "六类银行",
      BANK_SEVEN: "七类银行",
      BANK_EIGHT: "八类银行",
      BANK_NINE: "九类银行",
      BANK_TEN: "十类银行",
      BANK_ZBANK: "众邦渠道-众邦银行",
      FINANCE_ONE: "一类财务公司",
      FINANCE_TWO: "二类财务公司",
      FINANCE_THREE: "三类财务公司",
      FINANCE_FOUR: "四类财务公司",
      FINANCE_FIVE: "五类财务公司"
    },
    // acceptBankLevelTypeNum：承兑行等级
    acceptBankLevelTypeNum: {
      1: "一类银行",
      2: "二类银行",
      3: "三类银行",
      4: "四类银行",
      5: "五类银行",
      6: "六类银行",
      7: "七类银行",
      8: "八类银行",
      9: "九类银行",
      10: "十类银行"
    },
    // 承兑行分类
    acceptorLevel: {
      1: "一类行",
      2: "二类行",
      3: "三类行",
      4: "四类行",
      5: "五类行",
      6: "六类行",
      7: "七类行",
      8: "八类行",
      9: "九类行",
      10: "十类行",
      11: "十一类行",
      12: "十二类行",
      13: "十三类行",
      14: "十四类行",
      15: "十五类行",
      16: "一类财务公司",
      17: "二类财务公司",
      18: "三类财务公司",
      19: "四类财务公司",
      20: "五类财务公司",
      21: "六类财务公司",
      22: "七类财务公司",
      23: "八类财务公司",
      24: "九类财务公司",
      25: "十类财务公司",
      50: "其他银行",
      61: "众邦银行",
      100: "华润银行"
    },
    // 承兑行工作时间
    acceptorWorkTime: {
      TEST: {
        workInfo: [
          {
            desHtml: "08:30-17:10最大票面<span>500</span>万",
            more:
              "工作日8:00-20:00最大票面1000万，节假日前最后一个工作日17:10-20:00受理金额单张不超过100万元，其余时间段的17:10-20:00提票金额超过100万元的，在次日早上10:00前到账"
          },
          {
            desHtml: "17:10-20:00最大票面<span>100</span>万"
          }
        ],
        holidayInfo: [
          {
            desHtml: "08:30-20:00最大票面<span>100</span>万"
          }
        ]
      },
      FM: {
        workInfo: [
          {
            desHtml: "08:30-17:10最大票面<span>500</span>万"
          },
          {
            desHtml: "17:10-20:00最大票面<span>100</span>万"
          }
        ],
        holidayInfo: [
          {
            desHtml: "08:30-20:00最大票面<span>100</span>万"
          }
        ]
      },
      FUMIN: {
        workInfo: [
          {
            desHtml: "08:30-17:10最大票面<span>500</span>万"
          },
          {
            desHtml: "17:10-20:00最大票面<span>100</span>万"
          }
        ],
        holidayInfo: [
          {
            desHtml: "08:30-20:00最大票面<span>100</span>万"
          }
        ]
      },
      WHLH: {
        workInfo: [
          {
            desHtml: "08:30-17:10最大票面<span>500</span>万"
          },
          {
            desHtml: "17:10-20:00最大票面<span>100</span>万"
          }
        ],
        holidayInfo: [
          {
            desHtml: "08:30-20:00最大票面<span>500</span>万"
          }
        ]
      },
      WZ: {
        workInfo: [
          {
            desHtml: "08:15-17:10最大票面<span>500</span>万"
          },
          {
            desHtml: "17:10-19:30最大票面<span>100</span>万"
          }
        ],
        holidayInfo: [
          {
            desHtml: "08:15-19:30最大票面<span>500</span>万"
          }
        ]
      },
      YNHT: {
        workInfo: [
          {
            desHtml: "09:00-16:30最大票面<span>500</span>万"
          }
        ],
        holidayInfo: []
      },
      ZBANK: {
        workInfo: [
          {
            desHtml: "09:30-16:30最大票面<span>500</span>万"
          }
        ],
        holidayInfo: []
      },
      PINGAN: {
        workInfo: [
          {
            desHtml: "09:00-17:10票面总额限制<span>3000</span>万以内（含）"
          },
          {
            desHtml: "17:10-18:30票面总金额限制<span>100</span>万以下（含）"
          }
        ],
        holidayInfo: []
      },
      SANXIANG: {
        workInfo: [
          {
            desHtml: "09:30-17:00最大票面<span>500</span>万"
          }
        ],
        holidayInfo: []
      },
      MYBANK: {
        workInfo: [
          {
            desHtml: "08:00-17:10最大票面<span>500</span>万"
          },
          {
            desHtml: "17:10-20:00最大票面<span>100</span>万"
          }
        ],
        holidayInfo: [
          {
            desHtml: "08:00-20:00最大票面<span>500</span>万"
          }
        ]
      },
      BAIXIN: {
        workInfo: [
          {
            desHtml: "08:00-20:00最大票面<span>1000</span>万",
            more:
              "工作日8:00-20:00最大票面1000万，节假日前最后一个工作日17:10-20:00受理金额单张不超过100万元，其余时间段的17:10-20:00提票金额超过100万元的，在次日早上10:00前到账"
          }
        ],
        holidayInfo: [
          {
            desHtml: "08:00-20:00最大票面<span>500</span>万"
          }
        ]
      },
      HUARUN: {
        workInfo: [
          {
            desHtml: "09:30-17:00单张金额不大于<span>500</span>万"
          }
        ],
        holidayInfo: []
      },
    },
    // 银行颜色
    bankColor: {
      WZ: "#96C3FF", // 微众
      YNHT: "#FFA7A7", // 红塔
      FM: "#61A6DF", // 富民
      ZBANK: "#88EEE5", // 众邦
      WHLH: "#FFDEA2", // 蓝海
      SANXIANG: "#D0787F", // 三湘
      TEST: "#4294FF", // 测试
      BAIXIN: "#FFAD7D", // 百信
      PINGAN: "#FF8D5A", // 平安
      HUARUN: "#FFFAF2" // 华润
    }
  },

  // 屏幕尺寸
  windowResizeW: document.documentElement.clientWidth,
  windowResizeH: document.documentElement.clientHeight
};

const getters = {};

// 放置公共方法  mutations可以改变state状态对象的值
const mutations = {};

// 暴露，让外部可以引用
export default new Vuex.Store({
  state,
  getters,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/store.js